/**
 * Whether `error` is a request that was cancelled on purpose — React Query aborting a query's
 * `signal` when its component unmounts or its key changes. A cancellation is not a failure: let it
 * propagate so React Query settles the query as cancelled, but never log it as an error (LAR-585).
 */
export const isAbortError = (error: unknown): boolean =>
  (error instanceof DOMException || error instanceof Error) &&
  error.name === "AbortError";

/**
 * Whether a caught error is the cancellation of the request `signal` belongs to. Checks the signal
 * too: once it has aborted, whatever the request rejected with is a consequence of the abort.
 */
export const isCancellation = (
  error: unknown,
  signal: AbortSignal | undefined
): boolean => isAbortError(error) || signal?.aborted === true;
